module.exports = __webpack_public_path__ + "static/media/nikon_bookb.3459a45e.png";